export const defaultToolbarOptions = {
  show: true,
  tools: {
    download: true, // Hamburger icon for exporting
    selection: false, // Disable selection tool
    zoom: false, // Disable zoom tool
    zoomin: false, // Disable zoom-in tool
    zoomout: false, // Disable zoom-out tool
    pan: false, // Disable pan tool
    reset: true, // Enable reset zoom tool
  },
};